export default __webpack_public_path__ + "static/media/menu2.54243db1.png";